import React, {useState, useEffect} from 'react';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Grid
} from '@material-ui/core';
import {Delete, Edit} from '@material-ui/icons';
import api from "../../api";
import LoadingSpinner from "../Loading";
import {toast} from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import "../../css/global.css";
import {createTheme, ThemeProvider} from "@mui/material";
import {e2p, formatNumber} from "../../utils/utils";
import {Link} from "react-router-dom";

const theme = createTheme({
    palette: {
        primary: {
            main: '#ffe052'
        },
    },
});

function CompanyList() {
    const [companies, setCompanies] = useState([]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteCompanyId, setDeleteCompanyId] = useState(null);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [editCompanyId, setEditCompanyId] = useState(null);
    const [editCompanyName, setEditCompanyName] = useState('');
    const [editCompanyPhone, setEditCompanyPhone] = useState('');
    const [editCompanyAddress, setEditCompanyAddress] = useState('');
    const [editCompanyHasSms, setEditCompanyHasSms] = useState(false);
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [newCompanyName, setNewCompanyName] = useState('');
    const [newCompanyPhone, setNewCompanyPhone] = useState('');
    const [newCompanyAddress, setNewCompanyAddress] = useState('');
    const [newCompanyHasSms, setNewCompanyHasSms] = useState(true);
    const [newCompanyUserName, setNewCompanyUserName] = useState('');
    const [newCompanyUserUserName, setNewCompanyUserUserName] = useState('');
    const [newCompanyUserMobileNumber, setNewCompanyUserMobileNumber] = useState('');
    const [newCompanyUserPassword, setNewCompanyUserPassword] = useState('');
    const [createCompanyError, setCreateCompanyError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleEditOpen = (companyId, companyName, companyPhone, companyAddress, companyHasSms) => {
        setOpenEditDialog(true);
        setEditCompanyId(companyId);
        setEditCompanyName(companyName);
        setEditCompanyPhone(companyPhone);
        setEditCompanyAddress(companyAddress);
        setEditCompanyHasSms(companyHasSms);
    };

    const handleEditClose = () => {
        setOpenEditDialog(false);
        setEditCompanyId(null);
        setEditCompanyName('');
        setEditCompanyPhone('');
        setEditCompanyAddress('');
        setEditCompanyHasSms(false);
    };

    const handleDeleteOpen = (companyId) => {
        setOpenDeleteDialog(true);
        setDeleteCompanyId(companyId);
    };

    const handleDeleteClose = () => {
        setOpenDeleteDialog(false);
        setDeleteCompanyId(null);
    };

    const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))

    const handleEditSubmit = async () => {
        setIsLoading(true)
        try {
            const response = await api.post(`/company/${editCompanyId}`, {
                company: editCompanyName,
                phone_number: p2e(editCompanyPhone),
                address: editCompanyAddress,
                has_sms: editCompanyHasSms,
            });
            setIsLoading(false)
            handleEditClose();
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };

    const handleDeleteSubmit = async () => {
        setIsLoading(true)
        try {
            await api.delete(`/company/${deleteCompanyId}`);
            setIsLoading(false)
            handleDeleteClose();
        } catch (error) {
            toast.error(error.response.data.message)
        }
    };

    const handleCreateOpen = () => {
        setOpenCreateDialog(true);
    };

    const handleCreateClose = () => {
        setOpenCreateDialog(false);
        setNewCompanyName('');
        setNewCompanyPhone('');
        setNewCompanyAddress('');
        setNewCompanyHasSms(true);
        setNewCompanyUserName('');
        setNewCompanyUserUserName('');
        setNewCompanyUserMobileNumber('');
        setNewCompanyUserPassword('');
        setCreateCompanyError('');
        window.location.reload();
    };

    const createCompany = async (company, phone_number, address, hasSms, user_name, user_username, user_mobile, password) => {
        try {
            const response = await api.post('/company', {
                'company': company,
                'phone_number': p2e(phone_number),
                'address': address,
                'has_sms': hasSms,
                'user': {
                    'name': user_name,
                    'username': p2e(user_username),
                    'mobile_number': p2e(user_mobile),
                    'password': password
                }
            })
                .then((res) => {
                    toast.success(res.data.message)
                    setIsLoading(false)
                    handleCreateClose()
                })
        } catch (error) {
            setIsLoading(false)
            toast.error(error.response.data.message)
        }
    };

    const handleCreateSubmit = async () => {
        if (
            !newCompanyName ||
            !newCompanyPhone ||
            !newCompanyAddress ||
            !newCompanyUserUserName ||
            !newCompanyUserMobileNumber ||
            !newCompanyUserPassword
        ) {
            toast.error('لطفا همه ی فیلد های الزامی را پر کنید');
            return;
        }
        setIsLoading(true)
        try {
            const response = await createCompany(
                newCompanyName,
                newCompanyPhone,
                newCompanyAddress,
                newCompanyHasSms,
                newCompanyUserName,
                newCompanyUserUserName,
                newCompanyUserMobileNumber,
                newCompanyUserPassword);
        } catch (error) {
            toast.error(error.response.data.message)
            setIsLoading(false)
        }
    };

    useEffect(() => {
        setIsLoading(true)

        async function fetchData() {
            const response = await api.get("/company");
            console.log(response)
            setCompanies(response.data.data);
            setIsLoading(false)
        }

        fetchData();
    }, []);

    return (
        <div>
            {isLoading ? <LoadingSpinner/> :
                <div className="content-wrapper">
                    <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="card border-3 rounded-4 border-dark mb-4">
                                    <div className="card-header bg-dark text-center">
                                        <button
                                            className='btn btn-lg btn-dark fw-bold fs-5'
                                            onClick={handleCreateOpen}
                                        >
                                            <AddIcon/> ایجاد صافکاری جدید
                                        </button>
                                    </div>
                                    <div className="card-body">
                                        <div className='table-responsive'>
                                            <table
                                                className="table table-hover table-striped table-bordered table-rounded">
                                                <thead>
                                                <tr className="text-center shadow pb-4"
                                                    style={{backgroundColor: 'var(--header-color)'}}>
                                                    <th>نام صافکاری</th>
                                                    <th>شماره تلفن</th>
                                                    <th>آدرس</th>
                                                    <th>موجودی (ریال)</th>
                                                    <th>ویرایش</th>
                                                    <th>حذف</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {companies.map(company => (
                                                    <tr key={company.id}>
                                                        <td className="text-center">
                                                            {company.company}
                                                        </td>
                                                        <td className="text-center">{company.phone_number}</td>
                                                        <td>{company.address}</td>
                                                        <td className="text-center">
                                                            <button className="btn btn-outline-gray" disabled={false}>
                                                                <Link
                                                                    to={`/admin/transactions/${company.id}`}
                                                                    className="text-black"
                                                                >
                                                                    <p className="my-auto text-black">{e2p(formatNumber(company.wallet.balance))}</p>
                                                                </Link>
                                                            </button>
                                                        </td>
                                                        <td className="text-center">
                                                            <IconButton onClick={() => handleEditOpen(
                                                                company.id,
                                                                company.company,
                                                                company.phone_number,
                                                                company.address,
                                                                company.has_sms
                                                            )}>
                                                                <Edit color="primary"/>
                                                            </IconButton>
                                                        </td>
                                                        <td className="text-center">
                                                            <IconButton onClick={() => handleDeleteOpen(company.id)}>
                                                                <Delete color="secondary"/>
                                                            </IconButton>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <ThemeProvider theme={theme}>
                                    <Dialog className="text-center" open={openDeleteDialog} onClose={handleDeleteClose}>
                                        <DialogTitle className="bg-dark">
                                            <p className="text-white">حذف صافکاری</p>
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText>
                                                آیا مطمئن هستید که میخواهید صافکاری را حذف کنید ؟
                                            </DialogContentText>
                                        </DialogContent>
                                        <input className='btn btn-danger mx-5 mb-2 mt-3' type="submit"
                                               onClick={handleDeleteSubmit}
                                               value="حذف"
                                        />
                                        <input className='btn btn-secondary mx-5 mb-2' type='button'
                                               onClick={handleDeleteClose}
                                               value="انصراف"
                                        />
                                    </Dialog>
                                    <Dialog open={openEditDialog} onClose={handleEditClose}>
                                        <DialogTitle className="bg-dark">
                                            <p className="text-white">ویرایش اطلاعات</p>
                                        </DialogTitle>
                                        <DialogContent>
                                            <form>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>نام صافکاری</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <input
                                                            required
                                                            type='text'
                                                            variant="outlined"
                                                            value={editCompanyName}
                                                            onChange={e => setEditCompanyName(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>شماره تلفن</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <input
                                                            required
                                                            type='text'
                                                            maxLength={11}
                                                            variant="outlined"
                                                            value={editCompanyPhone}
                                                            onChange={e => setEditCompanyPhone(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>آیا این صافکاری دسترسی به پیامک
                                                            دارد ؟</label>
                                                        <div className='form-check'>
                                                            <label className='form-check-label'>بله</label>
                                                            <input
                                                                className={'form-check-input'}
                                                                type='radio'
                                                                value={editCompanyHasSms}
                                                                checked={editCompanyHasSms}
                                                                onChange={e => setEditCompanyHasSms(true)}
                                                            />
                                                        </div>
                                                        <div className='form-check'>
                                                            <label className='form-check-label'>خیر</label>
                                                            <input
                                                                className={'form-check-input'}
                                                                type='radio'
                                                                checked={!editCompanyHasSms}
                                                                value={editCompanyHasSms}
                                                                onChange={e => setEditCompanyHasSms(false)}
                                                            />
                                                        </div>

                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>آدرس</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <textarea
                                                            required
                                                            variant="outlined"
                                                            value={editCompanyAddress}
                                                            onChange={e => setEditCompanyAddress(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </DialogContent>
                                        <input className='btn btn-warning mx-5 mb-2 mt-3' type="submit"
                                               onClick={handleEditSubmit}
                                               value="ذخیره"
                                        />
                                        <input className='btn btn-secondary mx-5 mb-2' type='button'
                                               onClick={handleEditClose}
                                               value="انصراف"
                                        />
                                    </Dialog>
                                    <Dialog open={openCreateDialog} onClose={handleCreateClose}>
                                        <DialogTitle className="text-center bg-dark">
                                            <p className="text-white my-auto text-center">ایجاد صافکاری جدید</p>
                                        </DialogTitle>
                                        <DialogContent>
                                            <form onSubmit={handleCreateSubmit}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>نام صافکاری</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <input
                                                            error={!!createCompanyError}
                                                            helperText={createCompanyError}
                                                            required
                                                            type='text'
                                                            variant="outlined"
                                                            value={newCompanyName}
                                                            onChange={e => setNewCompanyName(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>شماره تلفن</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <input
                                                            required
                                                            type='text'
                                                            maxLength={11}
                                                            variant="outlined"
                                                            value={newCompanyPhone}
                                                            onChange={e => setNewCompanyPhone(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>آدرس</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <textarea
                                                            variant="outlined"
                                                            value={newCompanyAddress}
                                                            onChange={e => setNewCompanyAddress(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>نام و نام خانوادگی مسئول</label>
                                                        <sup
                                                            className='text-danger'>*</sup>
                                                        <input
                                                            required
                                                            type='text'
                                                            variant="outlined"
                                                            value={newCompanyUserName}
                                                            onChange={e => setNewCompanyUserName(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>شماره ملی مسئول</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <input
                                                            type='text'
                                                            maxLength={10}
                                                            required
                                                            variant="outlined"
                                                            value={newCompanyUserUserName}
                                                            onChange={e => setNewCompanyUserUserName(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>شماره موبایل مسئول</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <input
                                                            type='text'
                                                            maxLength={11}
                                                            required
                                                            variant="outlined"
                                                            value={newCompanyUserMobileNumber}
                                                            onChange={e => setNewCompanyUserMobileNumber(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className='form-label'>رمز عبور</label> <sup
                                                        className='text-danger'>*</sup>
                                                        <input
                                                            type='text'
                                                            required
                                                            variant="outlined"
                                                            value={newCompanyUserPassword}
                                                            onChange={e => setNewCompanyUserPassword(e.target.value)}
                                                            className='form-control shadow'
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </DialogContent>
                                        <input className='btn btn-warning mx-5 mb-2 mt-3' type="submit"
                                               onClick={handleCreateSubmit}
                                               value="ذخیره"
                                        />
                                        <input className='btn btn-secondary mx-5 mb-2' type='button'
                                               onClick={handleCreateClose}
                                               value="انصراف"
                                        />
                                    </Dialog>
                                </ThemeProvider>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default CompanyList;
